
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[id]/[[...name]]",
      function () {
        return require("private-next-pages/shops/[id]/[[...name]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[id]/[[...name]]"])
      });
    }
  